module.exports = __webpack_public_path__ + "82485df33e7fceeb9835424f7534e916.pdf";